// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CircleLoader-module__font-s-10___WKo0e {
  font-size: 10px !important;
}

.CircleLoader-module__font-s-12___gQnL1 {
  font-size: 12px !important;
}

.CircleLoader-module__font-s-13___UE1a4 {
  font-size: 13px !important;
}

.CircleLoader-module__font-s-14___JMpvU {
  font-size: 14px !important;
}

.CircleLoader-module__font-s-15___BfbIK {
  font-size: 15px !important;
}

.CircleLoader-module__font-s-16___OpZrR {
  font-size: 16px !important;
}

.CircleLoader-module__font-s-18___VDm3n {
  font-size: 18px !important;
}

.CircleLoader-module__font-s-20___ebIz4 {
  font-size: 20px !important;
}

.CircleLoader-module__font-s-22___b54JU {
  font-size: 22px !important;
}

.CircleLoader-module__font-s-28___HgFOU {
  font-size: 28px !important;
}

.CircleLoader-module__font-w-400___JhIHI {
  font-weight: 400 !important;
}

.CircleLoader-module__font-w-500___BIh9A {
  font-weight: 500 !important;
}

.CircleLoader-module__font-w-600___wSC0i {
  font-weight: 600 !important;
}

.CircleLoader-module__font-w-700___e8LfW {
  font-weight: 700 !important;
}

.CircleLoader-module__p-5___xvtNa {
  padding: 5px !important;
}

.CircleLoader-module__p-12___tDRyW {
  padding: 12px !important;
}

.CircleLoader-module__p-16___LU2Ch {
  padding: 16px !important;
}

.CircleLoader-module__p-30___ZGQey {
  padding: 30px !important;
}

.CircleLoader-module__p-b-0___hy3fc {
  padding-bottom: 0 !important;
}

.CircleLoader-module__p-b-5___tgvbC {
  padding-bottom: 5px !important;
}

.CircleLoader-module__p-b-10___Xuhgx {
  padding-bottom: 10px !important;
}

.CircleLoader-module__p-b-12___EDuDq {
  padding-bottom: 12px !important;
}

.CircleLoader-module__p-b-16___G7lqz {
  padding-bottom: 16px !important;
}

.CircleLoader-module__p-b-18___Lm5Km {
  padding-bottom: 18px !important;
}

.CircleLoader-module__p-b-20___UCdHU {
  padding-bottom: 20px !important;
}

.CircleLoader-module__p-b-25___bWlY5 {
  padding-bottom: 25px !important;
}

.CircleLoader-module__p-b-30___jaZyF {
  padding-bottom: 30px !important;
}

.CircleLoader-module__p-b-50___Un6FO {
  padding-bottom: 50px !important;
}

.CircleLoader-module__p-t-0___n6iNE {
  padding-top: 0 !important;
}

.CircleLoader-module__p-t-12___fpywS {
  padding-top: 12px !important;
}

.CircleLoader-module__p-t-16___o6WrO {
  padding-top: 16px !important;
}

.CircleLoader-module__p-t-18___vIvry {
  padding-top: 18px !important;
}

.CircleLoader-module__p-t-20___Qw_ra {
  padding-top: 20px !important;
}

.CircleLoader-module__p-t-30___DK0dh {
  padding-top: 30px !important;
}

.CircleLoader-module__p-t-40___BVp9h {
  padding-top: 40px !important;
}

.CircleLoader-module__p-t-50___dxhAD {
  padding-top: 50px !important;
}

.CircleLoader-module__p-l-20___QyENL {
  padding-left: 20px !important;
}

.CircleLoader-module__p-l-30___aqrgy {
  padding-left: 30px !important;
}

.CircleLoader-module__p-l-40____K2hS {
  padding-left: 40px !important;
}

.CircleLoader-module__p-r-16___YeK6J {
  padding-right: 16px !important;
}

.CircleLoader-module__p-r-20___Hgm_m {
  padding-right: 20px !important;
}

.CircleLoader-module__p-r-30___o69J6 {
  padding-right: 30px !important;
}

.CircleLoader-module__p-r-50___zUcmh {
  padding-right: 50px !important;
}

.CircleLoader-module__p-r-60___hxJcO {
  padding-right: 60px !important;
}

.CircleLoader-module__m-b-1___nrZXQ {
  margin-bottom: 1px !important;
}

.CircleLoader-module__m-b-2___J_oXg {
  margin-bottom: 2px !important;
}

.CircleLoader-module__m-b-6___duQDF {
  margin-bottom: 6px !important;
}

.CircleLoader-module__m-b-8___fG4pe {
  margin-bottom: 8px !important;
}

.CircleLoader-module__m-b-10___Anatz {
  margin-bottom: 10px !important;
}

.CircleLoader-module__m-b-14___OJMyt {
  margin-bottom: 14px !important;
}

.CircleLoader-module__m-b-16___F44CA {
  margin-bottom: 16px !important;
}

.CircleLoader-module__m-b-20___ErwTt {
  margin-bottom: 20px !important;
}

.CircleLoader-module__m-b-22___b7Dfl {
  margin-bottom: 22px !important;
}

.CircleLoader-module__m-b-24___CstZT {
  margin-bottom: 24px !important;
}

.CircleLoader-module__m-b-30___ObtLv {
  margin-bottom: 30px !important;
}

.CircleLoader-module__m-b-32___WZVHh {
  margin-bottom: 32px !important;
}

.CircleLoader-module__m-b-40___ZWo8t {
  margin-bottom: 40px !important;
}

.CircleLoader-module__m-t-2___w8Hle {
  margin-top: 2px !important;
}

.CircleLoader-module__m-t-3___v6f65 {
  margin-top: 3px !important;
}

.CircleLoader-module__m-t-4___WRdVc {
  margin-top: 4px !important;
}

.CircleLoader-module__m-t-5___AJCXb {
  margin-top: 5px !important;
}

.CircleLoader-module__m-t-8___saKNF {
  margin-top: 8px !important;
}

.CircleLoader-module__m-t-10___Lkreh {
  margin-top: 10px !important;
}

.CircleLoader-module__m-t-15___XJKKO {
  margin-top: 15px !important;
}

.CircleLoader-module__m-t-16___HnoGg {
  margin-top: 16px !important;
}

.CircleLoader-module__m-t-20___REOzx {
  margin-top: 20px !important;
}

.CircleLoader-module__m-t-22___M01fo {
  margin-top: 22px !important;
}

.CircleLoader-module__m-t-30___C3hZ5 {
  margin-top: 30px !important;
}

.CircleLoader-module__m-t-32___zA7h5 {
  margin-top: 32px !important;
}

.CircleLoader-module__m-l-auto___aH1Sv {
  margin-left: auto !important;
}

.CircleLoader-module__m-l-4___PjUdd {
  margin-left: 4px !important;
}

.CircleLoader-module__m-l-5___bv92K {
  margin-left: 5px !important;
}

.CircleLoader-module__m-l-6___xtN4e {
  margin-left: 6px !important;
}

.CircleLoader-module__m-l-8___NtS_p {
  margin-left: 8px !important;
}

.CircleLoader-module__m-l-10___Yf3s7 {
  margin-left: 10px !important;
}

.CircleLoader-module__m-l-16____nywx {
  margin-left: 16px !important;
}

.CircleLoader-module__m-l-20___VQHhG {
  margin-left: 20px !important;
}

.CircleLoader-module__m-l-24___kRfnS {
  margin-left: 24px !important;
}

.CircleLoader-module__m-l-30___tfi6r {
  margin-left: 30px !important;
}

.CircleLoader-module__m-l-35___TQTIG {
  margin-left: 35px !important;
}

.CircleLoader-module__m-l-40___a1nh7 {
  margin-left: 40px !important;
}

.CircleLoader-module__m-r-8___AW5fM {
  margin-right: 8px !important;
}

.CircleLoader-module__m-r-10___BVZTr {
  margin-right: 10px !important;
}

.CircleLoader-module__m-r-16___MWWMp {
  margin-right: 16px !important;
}

.CircleLoader-module__m-r-20___itBS3 {
  margin-right: 20px !important;
}

.CircleLoader-module__m-r-24___BsyXw {
  margin-right: 24px !important;
}

.CircleLoader-module__m-r-30___RQ7YH {
  margin-right: 30px !important;
}

.CircleLoader-module__m-r-40___Rx9PU {
  margin-right: 40px !important;
}

.CircleLoader-module__border-r-3___ObX9H {
  border-radius: 3px !important;
}

.CircleLoader-module__border-r-4___Kr3UM {
  border-radius: 4px !important;
}

.CircleLoader-module__border-r-6___FVVuO {
  border-radius: 6px !important;
}

.CircleLoader-module__border-r-10___eGfDJ {
  border-radius: 10px !important;
}

.CircleLoader-module__border-r-12___YUOuX {
  border-radius: 12px !important;
}

.CircleLoader-module__border-r-16___rZU14 {
  border-radius: 16px !important;
}

.CircleLoader-module__border-r-50___JPGy7 {
  border-radius: 50% !important;
}

.CircleLoader-module__primary-border___vMa4F {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CircleLoader-module__primary-border-b___txJ0O {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CircleLoader-module__primary-border-t___qnRh7 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CircleLoader-module__primary-border-l___uVWCM {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CircleLoader-module__primary-border-r___D1Wvg {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CircleLoader-module__secondary-border___PqYet {
  border: 1px solid #637768;
}

.CircleLoader-module__secondary-border-b___9MkKy {
  border-bottom: 1px solid #637768;
}

.CircleLoader-module__secondary-border-t___u3y_3 {
  border-top: 1px solid #637768;
}

.CircleLoader-module__secondary-border-l___xXian {
  border-left: 1px solid #637768;
}

.CircleLoader-module__secondary-border-r___hs2ZY {
  border-right: 1px solid #637768;
}

.CircleLoader-module__gap-0___RIuxM {
  gap: 0 !important;
}

.CircleLoader-module__gap-2___b1CDP {
  gap: 2px !important;
}

.CircleLoader-module__gap-4___hRhN7 {
  gap: 4px !important;
}

.CircleLoader-module__gap-5___G90yZ {
  gap: 5px !important;
}

.CircleLoader-module__gap-6___NZ70I {
  gap: 6px !important;
}

.CircleLoader-module__gap-8___Q6VGf {
  gap: 8px !important;
}

.CircleLoader-module__gap-10___Cmrqt {
  gap: 10px !important;
}

.CircleLoader-module__gap-12___i_005 {
  gap: 12px !important;
}

.CircleLoader-module__gap-14___BgkSd {
  gap: 14px !important;
}

.CircleLoader-module__gap-16___t86J7 {
  gap: 16px !important;
}

.CircleLoader-module__gap-18___WPOfk {
  gap: 18px !important;
}

.CircleLoader-module__gap-20___VnBWl {
  gap: 20px !important;
}

.CircleLoader-module__gap-24___PmGBI {
  gap: 24px !important;
}

.CircleLoader-module__gap-26___bRhDF {
  gap: 26px !important;
}

.CircleLoader-module__gap-30___YwBcN {
  gap: 30px !important;
}

.CircleLoader-module__gap-32___I1kb3 {
  gap: 32px !important;
}

.CircleLoader-module__gap-40___c2K_r {
  gap: 40px !important;
}

.CircleLoader-module__gap-50___w71rT {
  gap: 50px !important;
}

.CircleLoader-module__flex-1___gccN6 {
  flex: 1;
}

.CircleLoader-module__flex-none___fir3p {
  flex: none !important;
}

.CircleLoader-module__flex-column___L0obs {
  display: flex;
  flex-direction: column !important;
}

.CircleLoader-module__flex-row___PS_dH {
  display: flex;
  flex-direction: row !important;
}

.CircleLoader-module__vertically-centered___KeTkk {
  display: flex;
  align-items: center !important;
}

.CircleLoader-module__horizontally-centered___vye5R {
  display: flex;
  justify-content: center !important;
}

.CircleLoader-module__horizontally-end___wRIMm {
  display: flex;
  justify-content: end !important;
}

.CircleLoader-module__vertically-start___tLbPx {
  display: flex;
  align-items: start !important;
}

.CircleLoader-module__space-between___CmyON {
  display: flex;
  justify-content: space-between !important;
}

.CircleLoader-module__flex-wrap___To2e_ {
  flex-wrap: wrap !important;
}

.CircleLoader-module__height-100___Te__0 {
  height: 100%;
}

.CircleLoader-module__width-50___hH1R8 {
  width: 50% !important;
}

.CircleLoader-module__width-100___Lgtmh {
  width: 100%;
}

.CircleLoader-module__cursor-pointer___MXXoG {
  cursor: pointer;
}

.CircleLoader-module__cursor-not-allowed___mjB8s {
  cursor: not-allowed !important;
}

.CircleLoader-module__absolute-centered___WTHi9 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CircleLoader-module__absolute___XHy6u {
  position: absolute;
}

.CircleLoader-module__relative___KtvO_ {
  position: relative;
}

.CircleLoader-module__fixed___W1Ugk {
  position: fixed;
}

.CircleLoader-module__visible___kVtIK {
  opacity: 1;
}

.CircleLoader-module__invisible___lsHKD {
  opacity: 0;
}

.CircleLoader-module__col-90___rpBNE {
  width: 90% !important;
}

.CircleLoader-module__col-auto___xs1Z3 {
  width: auto !important;
}

.CircleLoader-module__medical-tabs___Wtupw {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CircleLoader-module__medical-table-new___lukVQ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CircleLoader-module__medical-table-new___lukVQ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CircleLoader-module__medical-table-new___lukVQ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CircleLoader-module__medical-table-new___lukVQ::-webkit-scrollbar-track {
  display: none;
}
.CircleLoader-module__medical-table-new___lukVQ.CircleLoader-module__no-pagination___WxNPO {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CircleLoader-module__medical-table-new___lukVQ.CircleLoader-module__no-pagination___WxNPO:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CircleLoader-module__medical-table-new___lukVQ.CircleLoader-module__no-pagination___WxNPO::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CircleLoader-module__medical-table-new___lukVQ.CircleLoader-module__no-pagination___WxNPO::-webkit-scrollbar-track {
  display: none;
}

.CircleLoader-module__medical-table-empty____k4rn {
  padding: 14px 40px !important;
}

.CircleLoader-module__icon-btn___gpRiw {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CircleLoader-module__search-icon___m4tkq {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CircleLoader-module__disable-select___qxdCz {
  user-select: none;
}

.CircleLoader-module__break-word___taVLm {
  word-break: break-word;
}

.CircleLoader-module__popup-clear-btn___DLEOK {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CircleLoader-module__scroll-m-b-20___OxwKn {
  scroll-margin-bottom: 20px;
}

.CircleLoader-module__container___ObNC4 {
  margin: auto;
  display: block;
}

.CircleLoader-module__background___Jx_17 {
  fill: none;
  stroke: transparent;
}

.CircleLoader-module__foreground___je6d0 {
  fill: none;
  stroke: white;
  transition: stroke-dashoffset 0.3s ease-in-out;
}

.CircleLoader-module__wrapper___EngPj {
  justify-content: center;
}
.CircleLoader-module__wrapper___EngPj .CircleLoader-module__label___wqths {
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/CircleLoader/CircleLoader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,UAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,UAAA;EACA,aAAA;EACA,8CAAA;AA8pBF;;AA3pBA;EACE,uBAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  margin: auto;\n  display: block;\n}\n\n.background {\n  fill: none;\n  stroke: transparent;\n}\n\n.foreground {\n  fill: none;\n  stroke: white;\n  transition: stroke-dashoffset 0.3s ease-in-out;\n}\n\n.wrapper {\n  justify-content: center;\n\n  .label {\n    color: get-color(greenNew, dark);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CircleLoader-module__font-s-10___WKo0e`,
	"fontS12": `CircleLoader-module__font-s-12___gQnL1`,
	"fontS13": `CircleLoader-module__font-s-13___UE1a4`,
	"fontS14": `CircleLoader-module__font-s-14___JMpvU`,
	"fontS15": `CircleLoader-module__font-s-15___BfbIK`,
	"fontS16": `CircleLoader-module__font-s-16___OpZrR`,
	"fontS18": `CircleLoader-module__font-s-18___VDm3n`,
	"fontS20": `CircleLoader-module__font-s-20___ebIz4`,
	"fontS22": `CircleLoader-module__font-s-22___b54JU`,
	"fontS28": `CircleLoader-module__font-s-28___HgFOU`,
	"fontW400": `CircleLoader-module__font-w-400___JhIHI`,
	"fontW500": `CircleLoader-module__font-w-500___BIh9A`,
	"fontW600": `CircleLoader-module__font-w-600___wSC0i`,
	"fontW700": `CircleLoader-module__font-w-700___e8LfW`,
	"p5": `CircleLoader-module__p-5___xvtNa`,
	"p12": `CircleLoader-module__p-12___tDRyW`,
	"p16": `CircleLoader-module__p-16___LU2Ch`,
	"p30": `CircleLoader-module__p-30___ZGQey`,
	"pB0": `CircleLoader-module__p-b-0___hy3fc`,
	"pB5": `CircleLoader-module__p-b-5___tgvbC`,
	"pB10": `CircleLoader-module__p-b-10___Xuhgx`,
	"pB12": `CircleLoader-module__p-b-12___EDuDq`,
	"pB16": `CircleLoader-module__p-b-16___G7lqz`,
	"pB18": `CircleLoader-module__p-b-18___Lm5Km`,
	"pB20": `CircleLoader-module__p-b-20___UCdHU`,
	"pB25": `CircleLoader-module__p-b-25___bWlY5`,
	"pB30": `CircleLoader-module__p-b-30___jaZyF`,
	"pB50": `CircleLoader-module__p-b-50___Un6FO`,
	"pT0": `CircleLoader-module__p-t-0___n6iNE`,
	"pT12": `CircleLoader-module__p-t-12___fpywS`,
	"pT16": `CircleLoader-module__p-t-16___o6WrO`,
	"pT18": `CircleLoader-module__p-t-18___vIvry`,
	"pT20": `CircleLoader-module__p-t-20___Qw_ra`,
	"pT30": `CircleLoader-module__p-t-30___DK0dh`,
	"pT40": `CircleLoader-module__p-t-40___BVp9h`,
	"pT50": `CircleLoader-module__p-t-50___dxhAD`,
	"pL20": `CircleLoader-module__p-l-20___QyENL`,
	"pL30": `CircleLoader-module__p-l-30___aqrgy`,
	"pL40": `CircleLoader-module__p-l-40____K2hS`,
	"pR16": `CircleLoader-module__p-r-16___YeK6J`,
	"pR20": `CircleLoader-module__p-r-20___Hgm_m`,
	"pR30": `CircleLoader-module__p-r-30___o69J6`,
	"pR50": `CircleLoader-module__p-r-50___zUcmh`,
	"pR60": `CircleLoader-module__p-r-60___hxJcO`,
	"mB1": `CircleLoader-module__m-b-1___nrZXQ`,
	"mB2": `CircleLoader-module__m-b-2___J_oXg`,
	"mB6": `CircleLoader-module__m-b-6___duQDF`,
	"mB8": `CircleLoader-module__m-b-8___fG4pe`,
	"mB10": `CircleLoader-module__m-b-10___Anatz`,
	"mB14": `CircleLoader-module__m-b-14___OJMyt`,
	"mB16": `CircleLoader-module__m-b-16___F44CA`,
	"mB20": `CircleLoader-module__m-b-20___ErwTt`,
	"mB22": `CircleLoader-module__m-b-22___b7Dfl`,
	"mB24": `CircleLoader-module__m-b-24___CstZT`,
	"mB30": `CircleLoader-module__m-b-30___ObtLv`,
	"mB32": `CircleLoader-module__m-b-32___WZVHh`,
	"mB40": `CircleLoader-module__m-b-40___ZWo8t`,
	"mT2": `CircleLoader-module__m-t-2___w8Hle`,
	"mT3": `CircleLoader-module__m-t-3___v6f65`,
	"mT4": `CircleLoader-module__m-t-4___WRdVc`,
	"mT5": `CircleLoader-module__m-t-5___AJCXb`,
	"mT8": `CircleLoader-module__m-t-8___saKNF`,
	"mT10": `CircleLoader-module__m-t-10___Lkreh`,
	"mT15": `CircleLoader-module__m-t-15___XJKKO`,
	"mT16": `CircleLoader-module__m-t-16___HnoGg`,
	"mT20": `CircleLoader-module__m-t-20___REOzx`,
	"mT22": `CircleLoader-module__m-t-22___M01fo`,
	"mT30": `CircleLoader-module__m-t-30___C3hZ5`,
	"mT32": `CircleLoader-module__m-t-32___zA7h5`,
	"mLAuto": `CircleLoader-module__m-l-auto___aH1Sv`,
	"mL4": `CircleLoader-module__m-l-4___PjUdd`,
	"mL5": `CircleLoader-module__m-l-5___bv92K`,
	"mL6": `CircleLoader-module__m-l-6___xtN4e`,
	"mL8": `CircleLoader-module__m-l-8___NtS_p`,
	"mL10": `CircleLoader-module__m-l-10___Yf3s7`,
	"mL16": `CircleLoader-module__m-l-16____nywx`,
	"mL20": `CircleLoader-module__m-l-20___VQHhG`,
	"mL24": `CircleLoader-module__m-l-24___kRfnS`,
	"mL30": `CircleLoader-module__m-l-30___tfi6r`,
	"mL35": `CircleLoader-module__m-l-35___TQTIG`,
	"mL40": `CircleLoader-module__m-l-40___a1nh7`,
	"mR8": `CircleLoader-module__m-r-8___AW5fM`,
	"mR10": `CircleLoader-module__m-r-10___BVZTr`,
	"mR16": `CircleLoader-module__m-r-16___MWWMp`,
	"mR20": `CircleLoader-module__m-r-20___itBS3`,
	"mR24": `CircleLoader-module__m-r-24___BsyXw`,
	"mR30": `CircleLoader-module__m-r-30___RQ7YH`,
	"mR40": `CircleLoader-module__m-r-40___Rx9PU`,
	"borderR3": `CircleLoader-module__border-r-3___ObX9H`,
	"borderR4": `CircleLoader-module__border-r-4___Kr3UM`,
	"borderR6": `CircleLoader-module__border-r-6___FVVuO`,
	"borderR10": `CircleLoader-module__border-r-10___eGfDJ`,
	"borderR12": `CircleLoader-module__border-r-12___YUOuX`,
	"borderR16": `CircleLoader-module__border-r-16___rZU14`,
	"borderR50": `CircleLoader-module__border-r-50___JPGy7`,
	"primaryBorder": `CircleLoader-module__primary-border___vMa4F`,
	"primaryBorderB": `CircleLoader-module__primary-border-b___txJ0O`,
	"primaryBorderT": `CircleLoader-module__primary-border-t___qnRh7`,
	"primaryBorderL": `CircleLoader-module__primary-border-l___uVWCM`,
	"primaryBorderR": `CircleLoader-module__primary-border-r___D1Wvg`,
	"secondaryBorder": `CircleLoader-module__secondary-border___PqYet`,
	"secondaryBorderB": `CircleLoader-module__secondary-border-b___9MkKy`,
	"secondaryBorderT": `CircleLoader-module__secondary-border-t___u3y_3`,
	"secondaryBorderL": `CircleLoader-module__secondary-border-l___xXian`,
	"secondaryBorderR": `CircleLoader-module__secondary-border-r___hs2ZY`,
	"gap0": `CircleLoader-module__gap-0___RIuxM`,
	"gap2": `CircleLoader-module__gap-2___b1CDP`,
	"gap4": `CircleLoader-module__gap-4___hRhN7`,
	"gap5": `CircleLoader-module__gap-5___G90yZ`,
	"gap6": `CircleLoader-module__gap-6___NZ70I`,
	"gap8": `CircleLoader-module__gap-8___Q6VGf`,
	"gap10": `CircleLoader-module__gap-10___Cmrqt`,
	"gap12": `CircleLoader-module__gap-12___i_005`,
	"gap14": `CircleLoader-module__gap-14___BgkSd`,
	"gap16": `CircleLoader-module__gap-16___t86J7`,
	"gap18": `CircleLoader-module__gap-18___WPOfk`,
	"gap20": `CircleLoader-module__gap-20___VnBWl`,
	"gap24": `CircleLoader-module__gap-24___PmGBI`,
	"gap26": `CircleLoader-module__gap-26___bRhDF`,
	"gap30": `CircleLoader-module__gap-30___YwBcN`,
	"gap32": `CircleLoader-module__gap-32___I1kb3`,
	"gap40": `CircleLoader-module__gap-40___c2K_r`,
	"gap50": `CircleLoader-module__gap-50___w71rT`,
	"flex1": `CircleLoader-module__flex-1___gccN6`,
	"flexNone": `CircleLoader-module__flex-none___fir3p`,
	"flexColumn": `CircleLoader-module__flex-column___L0obs`,
	"flexRow": `CircleLoader-module__flex-row___PS_dH`,
	"verticallyCentered": `CircleLoader-module__vertically-centered___KeTkk`,
	"horizontallyCentered": `CircleLoader-module__horizontally-centered___vye5R`,
	"horizontallyEnd": `CircleLoader-module__horizontally-end___wRIMm`,
	"verticallyStart": `CircleLoader-module__vertically-start___tLbPx`,
	"spaceBetween": `CircleLoader-module__space-between___CmyON`,
	"flexWrap": `CircleLoader-module__flex-wrap___To2e_`,
	"height100": `CircleLoader-module__height-100___Te__0`,
	"width50": `CircleLoader-module__width-50___hH1R8`,
	"width100": `CircleLoader-module__width-100___Lgtmh`,
	"cursorPointer": `CircleLoader-module__cursor-pointer___MXXoG`,
	"cursorNotAllowed": `CircleLoader-module__cursor-not-allowed___mjB8s`,
	"absoluteCentered": `CircleLoader-module__absolute-centered___WTHi9`,
	"absolute": `CircleLoader-module__absolute___XHy6u`,
	"relative": `CircleLoader-module__relative___KtvO_`,
	"fixed": `CircleLoader-module__fixed___W1Ugk`,
	"visible": `CircleLoader-module__visible___kVtIK`,
	"invisible": `CircleLoader-module__invisible___lsHKD`,
	"col90": `CircleLoader-module__col-90___rpBNE`,
	"colAuto": `CircleLoader-module__col-auto___xs1Z3`,
	"medicalTabs": `CircleLoader-module__medical-tabs___Wtupw`,
	"medicalTableNew": `CircleLoader-module__medical-table-new___lukVQ`,
	"noPagination": `CircleLoader-module__no-pagination___WxNPO`,
	"medicalTableEmpty": `CircleLoader-module__medical-table-empty____k4rn`,
	"iconBtn": `CircleLoader-module__icon-btn___gpRiw`,
	"searchIcon": `CircleLoader-module__search-icon___m4tkq`,
	"disableSelect": `CircleLoader-module__disable-select___qxdCz`,
	"breakWord": `CircleLoader-module__break-word___taVLm`,
	"popupClearBtn": `CircleLoader-module__popup-clear-btn___DLEOK`,
	"scrollMB20": `CircleLoader-module__scroll-m-b-20___OxwKn`,
	"container": `CircleLoader-module__container___ObNC4`,
	"background": `CircleLoader-module__background___Jx_17`,
	"foreground": `CircleLoader-module__foreground___je6d0`,
	"wrapper": `CircleLoader-module__wrapper___EngPj`,
	"label": `CircleLoader-module__label___wqths`
};
module.exports = ___CSS_LOADER_EXPORT___;
